<template>
    <div class="content-body reports-wrapper">
        <PageToolbar></PageToolbar>
        <DataTable></DataTable>
        <Pagination></Pagination>
        <ConfirmModal :open="confirm" />
        <MismatchRows :open="mismatch" />
    </div>
</template>

<script>
import { mapState } from "vuex";

import PageToolbar from "./transaction-upload/PageToolbar";
import DataTable from "./transaction-upload/DataTable";
import Pagination from "./transaction-upload/Pagination";
import ConfirmModal from "./transaction-upload/ConfirmModal";
import MismatchRows from "./transaction-upload/MismatchRows";

export default {
    name: "TransactionUpload",
    components: {
        PageToolbar,
        DataTable,
        Pagination,
        ConfirmModal,
        MismatchRows
    },
    data() {
        return {
            mismatch: false
        };
    },
    computed: {
        ...mapState("reportsTransactionUpload", ["confirm", "data_errors"])
    },
    watch: {
        data_errors: function(value) {
            if (value !== null) {
                this.mismatch = true;
            } else {
                this.mismatch = false;
            }
        }
    }
};
</script>
